<main id="tribe-events-pg-template" class="tribe-events-pg-template">
  <div id="epta-template" class="epta-row epta-template-1">
    <div class="epta-title-alone col-md-12">
      <h2>{{ event.title }}</h2>
    </div>
    <div class="col-md-8">
      <div class="epta-image-area">
        <div class="tribe-events-event-image">
          <img width="950" height="440" src="{{ event.featured_image | imageSrc : 'travels' : 'large' }}"
            class="attachment-full size-full wp-post-image" alt="">
        </div>
      </div>
      <div class="epta-content-area">
        <div class="tribe-events-single-event-description tribe-events-content" [innerHTML]="event.content">

        </div>
      </div>

      <div class="epta-share-area">
        <h3 class="tecset-share-title">Share This Travel</h3>
        <share-buttons [theme]="'material-dark'" [include]="['facebook','twitter','linkedin','pinterest','email']"
          [title]="event.title" [url]="siteUrl + router.url"
          [image]="event.featured_image | imageSrc : 'travels' : 'large'" [autoSetMeta]="false"></share-buttons>
      </div>

    </div>

    <div class="col-md-4 col-xs-12">
      <div class="femail item">
        <div class="puff cleared" id="p-716">
          <span class="tl"> </span>
          <span class="tr"> </span>
          <h3 class="wocc">DON'T MISS</h3>
          <ul *ngIf="sidebarTravels" class="link-bogr2 linkro-wocc ul-side-news">
            <li *ngFor="let travel of sidebarTravels; let index = index">

              <a class="a-side-news" href="{{ siteUrl + '/travel/details/' + travel.slug }}">

                <span class="pufftext">
                  <span class="arrow-small-r"></span>
                  <strong>
                    {{travel.title}}
                  </strong>
                </span>

                <img class="side-news-img" [src]="travel.featured_image | imageSrc:'travels' : 'medium'">
              </a>

            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>

</main>